<template>
    <div>
        <service-contract v-if="contract" :client-id="clientId" :claim-id="claimId" :service-form-id="serviceFormId" :historical="historical" :contract="contract"></service-contract> 
        <service-assign-contract-modal></service-assign-contract-modal>
        <div class="d-flex justify-content-between align-items-end">
            <h5 class="font-weight-bold">Services</h5>
            <button v-if="allowContracts && !contract" class="btn btn-sm btn-primary mb-1" title="Apply Contract" @click="assignContract()">
                <i class="fas fa-file-contract fa-lg fa-fw"></i>
            </button>
        </div>
        <table class="table table-striped table-sm">
            <thead>
                <tr>
                    <th></th>
                    <th colspan="2">Date(s) of Service</th>
                    <th>Place of</th>
                    <th v-if="showInstitutionalColumn"></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class="text-right">Allowable</th>
                    <th class="text-right">Estimated</th>
                    <th></th>
                </tr>
                <tr>
                    <th class="shrink">Line #</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Service</th>
                    <th v-if="showInstitutionalColumn">RVU</th>
                    <th>CPT/HCPCS</th>
                    <th>Modifier</th>
                    <th class="text-right">Charges</th>
                    <th class="text-right">Days/Units</th>
                    <th class="text-right">Amount</th>
                    <th class="text-right">Reimbursement</th>
                    <th class="pl-3">Provider NPI</th>
                </tr>
            </thead>
            <tbody>                       
                <tr v-for="serviceLine in lines" :key="serviceLine.id">
                    <td>{{ serviceLine.line_number }}</td>
                    <td class="shrink">{{ serviceLine.service_from }}</td>
                    <td class="shrink">{{ serviceLine.service_to }}</td>
                    <td class="text-center">{{ serviceLine.place_of_service }}</td>
                    <td v-if="showInstitutionalColumn">{{ serviceLine.revenue_code }}</td>
                    <td>{{ serviceLine.cpt_hcpcs }}</td>
                    <td>{{ serviceLine.modifiers }}</td>
                    <td class="text-right">{{ serviceLine.charge | currency }}</td>
                    <td class="text-right">{{ serviceLine.quantity }}</td>
                    <td class="text-right">{{ format(serviceLine.allowable_amount) }}</td>
                    <td class="text-right">{{ serviceLine.estimated_reimbursement | currency }}<sup v-if="contract">*</sup></td>
                    <td class="pl-3">{{ serviceLine.provider_npi }}</td>
                </tr>
                <tr>
                    <td class="font-weight-bold text-right" :colspan="colSpan"></td>
                    <td class="font-weight-bold text-right">
                        <span class="mr-3">Total:</span> {{ total | currency }}                                                              
                    </td>
                    <td></td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="font-italic text-muted" colspan="12">
                        <span v-if="contract">* <small>{{ ContractDisclaimer }}</small></span>
                    </td>
                </tr>
            </tfoot>
        </table>        
    </div>
</template>

<script>
import { DocumentType, ContractDisclaimer } from '../../constants.js';
import ServiceContract from './ServiceContractComponent.vue';
import ServiceAssignContractModal from './ServiceAssignContractComponent.vue';

export default {
    components: {
        ServiceContract,
        ServiceAssignContractModal
    },
    props: {
        clientId: Number,
        claimId: Number,
        serviceFormId: Number,
        documentTypeId: Number,
        historical: Boolean,
        lines: Array,
        contract: Object,
        allowContracts: Boolean
    },
    data() {
        return {
            DocumentType: DocumentType,
            ContractDisclaimer: ContractDisclaimer
        }
    },
    computed: {
        showInstitutionalColumn: function () {
            return (this.documentTypeId === DocumentType.CMS_1450) || this.lines.some(line => line.revenue_code);
        },
        colSpan: function () {
            return ((this.documentTypeId === DocumentType.CMS_1450) || this.lines.some(line => line.revenue_code)) ? 10 : 9;
        },
        total: function () {
            return this.lines.reduce((a, b) => a + parseFloat(b.estimated_reimbursement), 0);
        }
    },    
    methods: {
        format: function (value) {
            return isNaN(value) ? value :  this.$options.filters.currency(value);
        },
        assignContract: function () {
            eventHub.$emit('show-assign-contract-modal', this.clientId, this.claimId, this.serviceFormId, this.historical);
        }
    },
    created() {

    }
}
</script>

<style scoped>
    tr > td {
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 1rem;
        padding-right: 1rem;
        margin: 0; 
        white-space: nowrap;      
    }

    tr > th {
        padding-top: 0;
        padding-bottom: 0;
        padding-left: 1rem;
        padding-right: 1rem;
        margin: 0;
        white-space: nowrap;       
    }

    tr:nth-child(even) > th {
        border-top: none;
        line-height: 1em;
    }

    tr:nth-child(odd) > th {
        border-bottom: none;
    }
    
    .shrink {
        width: 1%;
    }
</style>